export default __webpack_public_path__ + "static/media/florayfauna4.879b9583.jpg";